<script>
  export default {
    created() {
      this.$router.push('/login?from=feedhive');
    },
  };
</script>
